import { useState } from 'react';
import type { RaffleRecord } from '../../api/types';
import { badgeColor, siteMeta } from '../../lib/siteMeta';
import { countdown, urgency } from '../../lib/countdown';

function hasImage(url: string | null): url is string {
  return !!url && url !== 'N/A' && /^https?:/.test(url);
}

/** Board tile: product shot on a light "shelf" well, countdown first. */
export function RaffleCard({
  raffle,
  now,
  onOpen,
}: {
  raffle: RaffleRecord;
  now: number;
  onOpen: () => void;
}) {
  const [broken, setBroken] = useState(false);
  const meta = siteMeta(raffle.site);
  const u = urgency(raffle.cutoff, now);
  const method = raffle.collection_methods?.[0];
  const showImage = hasImage(raffle.picture_url) && !broken;

  return (
    <button type="button" className={`rcard u-${u}`} onClick={onOpen}>
      <div className={`rcard-media ${showImage ? '' : 'is-empty'}`}>
        {showImage ? (
          <img src={raffle.picture_url ?? undefined} alt="" loading="lazy" decoding="async" onError={() => setBroken(true)} />
        ) : (
          <span className="rcard-ph" style={{ background: badgeColor(raffle.site) }}>
            {meta.short}
          </span>
        )}
        <span className="rcard-site">{raffle.site ?? 'Unknown'}</span>
        {raffle.nsf && <span className="rcard-flag">NSF</span>}
      </div>
      <div className="rcard-body">
        <div className="rcard-count">
          <span className="num">{countdown(raffle.cutoff, now)}</span>
          <span className="rcard-count-l">{u === 'closed' ? '' : 'left'}</span>
        </div>
        <div className="rcard-title">{raffle.product ?? 'Untitled raffle'}</div>
        <div className="rcard-meta">
          {raffle.price && raffle.price !== 'N/A' && <span className="num">{raffle.price.startsWith('$') ? raffle.price : `$${raffle.price}`}</span>}
          {method && <span>{method.replace(/[[\]'"]/g, '').toLowerCase()}</span>}
        </div>
      </div>
    </button>
  );
}
